import { QueryClient } from "@tanstack/react-query";
import { onError, onSuccess } from "./toastify.utils";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 5 * 60 * 1000
    }
  }
});

export function onSuccessMessage(data, status) {
  if (data?.status !== status) {
    if (data?.status === 422) {
      if (data?.data?.errors?.length) {
        Object.values(data?.data?.errors).forEach((item) => {
          onError(item?.join(""));
        });
      }
      if (typeof data?.data?.errors === "object") {
        Object.values(data?.data?.errors)?.forEach((item) => {
          onError(item?.join(""));
        });
      }
    } else {
      onError(data?.data?.error);
    }
  } else {
    onSuccess(data?.data?.message);
  }
}
